<template>
    <TestResult
        :token="token"
        :test-id="testId"
    ></TestResult>
</template>

<script>
import TestResult from 'education-component';

export default {
    data: () => ({
        token: localStorage.getItem('token'),
    }),
    components: {
        TestResult,
    },
    props: {
        projectoryTestId: Number,
    },
    computed: {
        testId() {
            return (Object.keys(this.$route.params).includes('projectoryTestId'))
                ? this.$route.params.projectoryTestId
                : this.projectoryTestId;

        },
    },
};
</script>